"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SingleOffer = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _models = require("../../../../models");
var _Product = require("../Product");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render single offer. It will render only one product.
 */ const SingleOffer = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { offerItems } = (0, _contexts.useOfferDetail)();
    const [offerItem] = offerItems;
    if (!offerItem) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId(_models.TestId.SingleOffer),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Product.Product, {
            isSingleOffer: true,
            offerItem: offerItem,
            position: 0
        })
    });
};
exports.SingleOffer = SingleOffer;
